// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2goYC","right":"Footer_right__2yhJR","buttons":"Footer_buttons__3nH_j"};